import { Routes } from '@angular/router';
import { AuthGuard } from '../core/guards/auth.guard';
import { AgentsComponent } from './agents.component';
import { AnalyticsComponent } from './analytics/analytics.component';
import { ConfigurationComponent } from './configuration/configuration.component';
import { MarkdownsComponent } from './markdowns/markdowns.component';
import { ConversationsComponent } from './conversations/conversations.component';

export const AGENTS_ROUTES: Routes = [
  {
    path: 'agents', component: AgentsComponent, canActivate: [AuthGuard], children: [
      { path: 'analytics', component: AnalyticsComponent, canActivate: [AuthGuard] },
      { path: 'configuration', component: ConfigurationComponent, canActivate: [AuthGuard] },
      { path: 'markdowns', component: MarkdownsComponent, canActivate: [AuthGuard] },
      { path: 'conversations', component: ConversationsComponent, canActivate: [AuthGuard] }
    ]
  }
];
